import { SelectAsyncInput } from '@core/components/Select';
import { parseHeaderForLinks } from '@core/util';
import { categoriaClasseApi } from 'app/services/api/planoContasApi';
import React from 'react';

const SelectCategoria = ({
  id,
  multiple,
  name,
  label,
  value,
  touched,
  error,
  onBlur,
  onChange,
  natureza = '',
  required,
  disabled,
  style,
}) => {
  return (
    <SelectAsyncInput
      style={style}
      multiple={multiple}
      id={id}
      required={required}
      name={name}
      label={label}
      value={value}
      onChange={(event, value) => {
        onChange({
          target: {
            id,
            value,
          },
        });
      }}
      touched={touched}
      error={error}
      onBlur={onBlur}
      getOptionKey={(option) => {
        return option?.id;
      }}
      getOptionLabel={(option) => {
        return option?.nome ? `${option.indice} - ${option?.nome}` : '';
      }}
      fetchData={async (query = '', next = 0) => {
        if (typeof query === 'object') {
          query = '';
        }

        const response = await categoriaClasseApi.pesquisar({
          size: 100,
          sort: 'indice',
          page: next,
          q: query,
          natureza,
        });

        const links = parseHeaderForLinks(response.headers.link);
        const totalItems = response.headers['x-total-count'];
        const data = response?.data || [];

        return { data, nextPage: links.next, totalItems };
      }}
      fetchOnFocus
      disabled={disabled}
    />
  );
};

export default SelectCategoria;
